import PropTypes from 'prop-types';
import React from 'react'

import { TextLength } from '~/components'
import { TextEdit } from '~/services'


export default class extends React.Component {
    static propTypes = {
		user: PropTypes.object.isRequired,
		editing_fields: PropTypes.bool.isRequired,
		isSessionUser: PropTypes.bool.isRequired,
		updateWebsite: PropTypes.func.isRequired,
	};

    state = {
        correct: false
    };

    componentDidMount() {
		this.validateURL( this.props.user.website )
	}

    validateURL = (val) => {

		var expression = /(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/gi;
		var regex = new RegExp(expression);

		if ( val.match(regex) ) {
			this.setState({
				correct: true
			})
		} else {
			this.setState({
				correct: false
			})
		}

		return this.state.correct ? val.match(regex)[0] : false;

	};

    updateWebsite = (e) => {
	
		let val = this.validateURL(e.target.value)
		if( !val ) return;
		this.props.updateWebsite(val);

	};

    render() {

		let { user, editing_fields, isSessionUser, updateField } = this.props,
			urlSet = !!user.website;
			
		if( !urlSet && !isSessionUser ) return null;
		
		return (

			
			<h6 id="website-field" className={"mtop0 mbot20 mbot10-xs overflow-text-hide " + (!urlSet ? 'text-dark-gray' : '')}>
				{ this.props.editing_fields
					? <TextLength type="url" 
								defaultValue={user.website} 
								onChange={this.updateWebsite} 
								placeholder={'https://bomacamp.com' + user.link}
								className={"form-control " + (this.state.correct ? 'border-bottom-mid-success' : 'border-bottom-mid-danger')}
								maxLength="80" />
					: (urlSet
						? <a href={user.website} target="_blank" className="low-style border-bottom-transparent">{user.website}</a>
						: 'https://bomacamp.com' + user.link
					)
				}
			</h6>

		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Profile/components/Header/components/Website.jsx